// -- starting point of the application (js part)
const app = new App();

